module.exports = __webpack_public_path__ + "static/img/95.6925dfff.png";